module.exports = __webpack_public_path__ + "img/guijihuifang.dbfac541.svg";